import {fromJS} from 'immutable';


export default (state, userData) => {

    return state.set('isAuthenticated', true)
        .set('user', fromJS(userData));
};
